import { Theme } from "@mui/material";

export const datepickerStyles = {
  "&.MuiDateRangeCalendar-root": {
    background: "transparent",
    padding: "1.5rem 0 0",
  },

  "&.MuiMultiInputDateRangeField-root": {
    flexDirection: "column",
    gap: 2,
    padding: "1.5rem 0 0",
  },

  ".MuiDateRangeCalendar-monthContainer": {
    minHeight: "373px",
    minWidth: "336px",
    background: "white",
    padding: "0.5rem 0.75rem 0",
    marginRight: "1rem",
    border: "none",
    borderRadius: "1rem",
    boxShadow:
      "0px 4px 50px 0px rgba(166, 166, 166, 0.20), 0px 1px 1px 0px rgba(242, 242, 242, 0.25)",
  },

  ".MuiPickersSlideTransition-root": {
    minHeight: "270px",
  },

  ".MuiDayCalendar-loadingContainer": {
    position: "relative",
  },

  ".MuiInputBase-root": {
    background: "white",
  },

  ".MuiFormControl-root:nth-child(2)": {
    margin: 0,
  },

  ".MuiDateRangePickerDay-day": {
    borderRadius: "0.5rem",
  },

  ".MuiDateRangePickerDay-rangeIntervalDayHighlightStart .MuiDateRangePickerDay-day":
    {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },

  ".MuiDateRangePickerDay-rangeIntervalDayHighlightEnd .MuiDateRangePickerDay-day":
    {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },

  ".MuiDateRangePickerDay-rangeIntervalDayHighlightStart.MuiDateRangePickerDay-rangeIntervalDayHighlightEnd .MuiDateRangePickerDay-day":
    {
      borderRadius: "0.5rem",
    },

  ".MuiDateRangePickerDay-root": {
    ":first-of-type": {
      borderTopLeftRadius: "0.5rem !important",
      borderBottomLeftRadius: "0.5rem !important",
    },

    "&:last-of-type": {
      borderTopRightRadius: "0.5rem !important",
      borderBottomRightRadius: "0.5rem !important",
    },
  },
};

export const getPickerStyles = (isRequestDay: boolean, bgColor?: string) => {
  const defaultBgColor = isRequestDay ? bgColor : "transparent";

  return {
    "&:hover, &:focus": {
      bgcolor: defaultBgColor,
      borderRadius: "0.5rem",
    },

    ".MuiDateRangePickerDay-rangeIntervalPreview": {
      bgcolor: defaultBgColor,
      borderColor: "white !important",
      borderRadius: "0.5rem !important",
      borderStyle: "solid !important",
    },

    "&.MuiPickersDay-dayWithMargin": {
      bgcolor: defaultBgColor,
      borderColor: "white",
      borderRadius: "0.5rem",
    },

    "&.MuiDateRangePickerDay-hiddenDayFiller .MuiDateRangePickerDay-rangeIntervalPreview":
      {
        bgcolor: "white",
      },
  };
};

export const getRangeIntervalStyles = (
  theme: Theme,
  isExcluded: boolean,
  isCustomExcluded: boolean
) => {
  let customFontColor = "initial";

  if (isExcluded) {
    customFontColor = "text.disabled";
  } else if (isCustomExcluded) {
    customFontColor = "#546e7a !important";
  }

  return {
    "&.MuiPickersDay-root": {
      color: customFontColor,
    },

    ".MuiDateRangePickerDay-notSelectedDate": {
      color: customFontColor,
    },

    "&.MuiDateRangePickerDay-rangeIntervalDayHighlight:has(.Mui-disabled)": {
      bgcolor: "transparent !important",
    },

    ".MuiPickersDay-today": {
      borderColor: "primary.dark",
      borderRadius: "0.5rem",
    },

    "&.MuiDateRangePickerDay-root": {
      borderRadius: 0,
    },

    "&.MuiDateRangePickerDay-rangeIntervalDayHighlight .MuiDateRangePickerDay-rangeIntervalPreview .MuiDateRangePickerDay-day":
      {
        borderTop: `1.5px solid ${theme.palette.primary.main}`,
        borderBottom: `1.5px solid ${theme.palette.primary.main}`,

        "&:not(.Mui-selected)": {
          borderRadius: 0,
        },
      },
  };
};

export const getAbsenceRequestDayStyles = (color: string) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color,
  fontWeight: 700,
});
